<template>
  <div class="participants-container">
    <!-- 科技感装饰元素 -->
    <div class="tech-corner top-left"></div>
    <div class="tech-corner top-right"></div>
    <div class="tech-corner bottom-left"></div>
    <div class="tech-corner bottom-right"></div>

    <!-- 横向滚动的参与者列表 -->
    <div class="participants-scroll" ref="scrollContainer">
      <div class="participants">
        <div
          class="participant"
          v-for="(user, index) in robotList"
          :key="index"
          :class="{'selected': user.id === selectedRobotId}"
          @click="selectRobot(user)"
        >
          <div class="participant-video">
            <div class="video-frame">
              <img :src="user.avatar" alt="参与者头像" :class="{'floating': user.online}" />
              <div class="mic-status" :class="{ 'muted': !user.online }"></div>
              <div class="frame-corner top-left"></div>
              <div class="frame-corner top-right"></div>
              <div class="frame-corner bottom-left"></div>
              <div class="frame-corner bottom-right"></div>
              <div class="status-indicator" :class="{ 'online': user.online, 'offline': !user.online }">
                {{ user.online ? $translate('online') : $translate('offline') }}
              </div>
            </div>
          </div>
          <div class="participant-name">{{ user.name }}</div>
          <div class="participant-id">ID: {{ user.serialNumber }}</div>
        </div>
      </div>
    </div>

    <!-- 调整分页控件位置 -->
    <div class="pagination-container">
      <div class="pagination">
        <div class="page-btn prev" @click="changePage(page - 1)" :class="{ disabled: page <= 1 }">
          <svg-icon name="arrow" class="page-icon arrow-left" />
        </div>

        <div class="page-info">
          <div class="current-page">{{ page }}</div>
          <div class="page-divider"></div>
          <div class="total-page">{{ totalPages }}</div>
        </div>

        <div class="page-btn next" @click="changePage(page + 1)" :class="{ disabled: page >= totalPages }">
          <svg-icon name="arrow" class="page-icon arrow-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index'
import { getTenantId } from "@/libs/util";

export default {
  props: {
    selectedRobotId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      robotList: [],
      total: 0,
      page: 1,
      pageSize: 15,
      totalPages: 1,
      tenantId: getTenantId()
    }
  },
  mounted() {
    this.getList();
    this.setupWheelScroll();
  },
  beforeDestroy() {
    this.removeWheelScroll();
  },
  methods: {
    // 获取机器人列表
    getList() {
      api.getData(`robot-server/robot/list?index=${this.page}`, this)
        .then(res => {
          if (res.state === 0) {
            this.$Notice && this.$Notice.error({
              title: this.$translate('getTip'),
              desc: res.msg
            });
          } else {
            this.robotList = res.data.rows.map(item => ({
              id: item.id,
              serialNumber: item.code,
              name: item.name,
              avatar: item.avatar || require('@/assets/images/voice/Robot-icon.png'),
              online: item.onlineStatus, // 模拟在线状态，实际应从接口获取
            }));
            this.total = res.data.total || 0;
            this.totalPages = Math.ceil(this.total / this.pageSize);
          }
        })
        .catch(error => {
          this.$Notice && this.$Notice.error({
            title: this.$translate('getRobotListErrorTitle'),
            desc: this.$translate('getRobotListFailed')
          });
        });
    },
    // 切换页码
    changePage(newPage) {
      if (newPage < 1 || newPage > this.totalPages || newPage === this.page) return;
      this.page = newPage;
      this.getList();
    },
    // 处理通话请求
    handleCall(user) {
      this.$emit('call', user);
      this.$Notice && this.$Notice.success({
        title: this.$translate('getTip'),
        desc: `${this.$translate('connectingToRobot')} ${user.name}...`
      });
    },

    // 添加新方法
    selectRobot(robot) {
      if (!robot.online) {
        this.$Notice && this.$Notice.warning({
          title: this.$translate('getTip'),
          desc: this.$translate('robotOfflineCannotCall')
        });
        return;
      }

      this.$emit('select-robot', robot);
    },

    // 设置鼠标滚轮横向滚动
    setupWheelScroll() {
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        scrollContainer.addEventListener('wheel', this.handleWheel, { passive: false });
      }
    },
    // 移除滚轮事件监听
    removeWheelScroll() {
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        scrollContainer.removeEventListener('wheel', this.handleWheel);
      }
    },
    // 处理滚轮事件
    handleWheel(event) {
      event.preventDefault();

      // 增加滚动灵敏度，将滚动量乘以一个系数
      const sensitivity = 2.5; // 增加灵敏度系数
      const scrollAmount = (event.deltaY || event.deltaX) * sensitivity;

      const scrollContainer = this.$refs.scrollContainer;

      if (scrollContainer) {
        // 使用平滑滚动API
        scrollContainer.scrollBy({
          left: scrollAmount,
          behavior: 'smooth' // 使用平滑滚动
        });
      }
    }
  }
}
</script>

<style scoped>
.participants-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: rgba(10, 20, 40, 0.7);
  border-radius: 15px;
  overflow: hidden;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.4),
    inset 0 0 20px rgba(0, 191, 255, 0.2);
  border: 1px solid rgba(0, 191, 255, 0.3);
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 科技感边角 */
.tech-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(0, 191, 255, 0.7);
  z-index: 5;
}

.tech-corner.top-left {
  top: 5px;
  left: 5px;
  border-right: none;
  border-bottom: none;
}

.tech-corner.top-right {
  top: 5px;
  right: 5px;
  border-left: none;
  border-bottom: none;
}

.tech-corner.bottom-left {
  bottom: 5px;
  left: 5px;
  border-right: none;
  border-top: none;
}

.tech-corner.bottom-right {
  bottom: 5px;
  right: 5px;
  border-left: none;
  border-top: none;
}

/* 修改滚动容器的CSS */
.participants-scroll {
  flex: 1;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px 0;
  scroll-behavior: smooth; /* 平滑滚动 */
  margin-bottom: 0;
  -webkit-overflow-scrolling: touch; /* 增加iOS设备上的滚动流畅度 */
  scroll-snap-type: x proximity; /* 添加滚动吸附 */
}

/* 让每个参与者卡片成为滚动吸附点 */
.participant {
  scroll-snap-align: center; /* 滚动吸附对齐方式 */
  /* 其他样式保持不变 */
}

.participants-scroll::-webkit-scrollbar {
  height: 6px;
}

.participants-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.participants-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 191, 255, 0.5);
  border-radius: 3px;
}

.participants-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 191, 255, 0.7);
}

.participants {
  display: flex;
  flex-wrap: nowrap;
  gap: 15px;
  padding: 0 15px;
  min-width: min-content;
  height: 100%;
}

.participant {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  width: 140px;
  margin: 0 5px;
  max-height: 190px; /* 限制最大高度 */
  overflow: hidden; /* 防止内容溢出 */
}

/* 当名称文字较多时，自动缩小视频区域高度 */
.participant-name:not(:empty) + .participant-id:not(:empty) ~ .participant-video,
.participant-name.multiline ~ .participant-video {
  height: 90px; /* 缩小的高度 */
}

.participant-video {
  width: 140px;
  height: 105px; /* 正常高度 */
  position: relative;
  background-color: rgba(10, 20, 40, 0.5);
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s, height 0.3s;
}

.video-frame {
  width: 100%;
  height: 97%;
  margin-top: 3%;
  position: relative;
  overflow: hidden;
  border: 2px solid rgba(0, 191, 255, 0.5);
  box-shadow:
    0 0 18px rgba(0, 191, 255, 0.3),
    inset 0 0 10px rgba(0, 191, 255, 0.2);
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-frame:hover {
  transform: translateY(-5px);
  box-shadow:
    0 5px 25px rgba(0, 191, 255, 0.4),
    inset 0 0 15px rgba(0, 191, 255, 0.3);
}

.frame-corner {
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(0, 191, 255, 0.7);
  z-index: 2;
}

.frame-corner.top-left {
  top: 3px;
  left: 3px;
  border-right: none;
  border-bottom: none;
}

.frame-corner.top-right {
  top: 3px;
  right: 3px;
  border-left: none;
  border-bottom: none;
}

.frame-corner.bottom-left {
  bottom: 3px;
  left: 3px;
  border-right: none;
  border-top: none;
}

.frame-corner.bottom-right {
  bottom: 3px;
  right: 3px;
  border-left: none;
  border-top: none;
}

.participant-video img {
  width: 85%;
  height: 85%;
  object-fit: contain;
}

/* 为在线状态的用户添加浮动动画 */
.participant:has(.status-indicator.online) .participant-video img {
  animation: floatImage 3s ease-in-out infinite alternate;
}

.mic-status {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  z-index: 3;
}

.mic-status:not(.muted) {
  background-color: #4caf50;
  box-shadow: 0 0 10px rgba(76, 175, 80, 0.7);
  animation: pulseBall 2s infinite alternate;
}

.mic-status.muted {
  background-color: #f44336;
  box-shadow: 0 0 10px rgba(244, 67, 54, 0.7);
}

.status-indicator {
  position: absolute;
  top: 6px;
  left: 6px;
  padding: 3px 8px;
  border-radius: 8px;
  font-size: 0.75em;
  z-index: 3;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.9);
}

.status-indicator.online {
  background-color: rgba(76, 175, 80, 0.85);
  border: 1px solid rgba(76, 175, 80, 1);
  box-shadow:
    0 0 10px rgba(76, 175, 80, 0.7),
    inset 0 0 5px rgba(255, 255, 255, 0.3);
  animation: statusPulse 2s infinite alternate;
}

.status-indicator.offline {
  background-color: rgba(244, 67, 54, 0.85);
  border: 1px solid rgba(244, 67, 54, 1);
  box-shadow:
    0 0 10px rgba(244, 67, 54, 0.7),
    inset 0 0 5px rgba(255, 255, 255, 0.3);
}

.participant-name {
  margin-top: 8px;
  font-size: 14px;
  color: #ffffff;
  white-space: normal; /* 改为normal允许换行 */
  overflow: visible; /* 移除overflow隐藏 */
  text-overflow: initial; /* 移除省略号 */
  max-width: 140px;
  text-shadow: 0 0 10px rgba(0, 191, 255, 0.7);
  word-wrap: break-word; /* 添加自动换行 */
  line-height: 1.3; /* 添加行高使文本更易读 */
  max-height: 36px; /* 最大高度限制为两行文字 */
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-line-clamp: 2; /* 最多显示2行 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  overflow: hidden; /* 超出部分隐藏 */
}

.participant-id {
  font-size: 12px;
  color: #ffca00;
  margin-top: 3px;
  margin-bottom: 5px; /* 添加底部间距 */
}

/* 替换分页样式，使用音乐播放器的样式 */
.pagination-container {
  position: absolute;
  bottom: 10px; /* 略微上移 */
  left: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  background: rgba(16, 32, 58, 0.7);
  border-radius: 16px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 191, 255, 0.3);
}

.page-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 191, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-btn:hover:not(.disabled) {
  background: rgba(0, 191, 255, 0.5);
  transform: scale(1.1);
  box-shadow: 0 0 15px rgba(0, 191, 255, 0.5);
}

.page-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-icon {
  font-size: 16px;
  color: #fff;
}

.arrow-right {
  transform: rotate(180deg);
}

.page-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

.current-page {
  min-width: 24px;
  text-align: center;
  animation: numberChange 0.3s ease;
  color: rgba(0, 191, 255, 0.9);
}

.page-divider {
  width: 15px;
  height: 2px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.8) 50%,
    transparent 100%
  );
}

.total-page {
  min-width: 24px;
  text-align: center;
  opacity: 0.8;
}

@keyframes pulse {
  0% {
    opacity: 0.7;
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.7);
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 15px rgba(76, 175, 80, 1);
  }
  100% {
    opacity: 0.7;
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.7);
  }
}

@keyframes statusPulse {
  0% {
    box-shadow: 0 0 10px rgba(76, 175, 80, 0.7);
  }
  100% {
    box-shadow: 0 0 15px rgba(76, 175, 80, 1);
  }
}

@keyframes pulseBall {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 10px rgba(76, 175, 80, 0.7);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 15px rgba(76, 175, 80, 1);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 10px rgba(76, 175, 80, 0.7);
  }
}

@keyframes floatImage {
  0% {
    transform: translateY(-3px);
  }
  100% {
    transform: translateY(3px);
  }
}

@keyframes numberChange {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 只添加选中状态的样式，保留原有样式 */
.participant.selected .video-frame {
  border: 2px solid rgba(0, 255, 128, 0.8);
  box-shadow:
    0 0 20px rgba(0, 255, 128, 0.4),
    inset 0 0 12px rgba(0, 255, 128, 0.3);
  transform: translateY(-5px);
}

.participant.selected .participant-name {
  color: rgba(0, 255, 128, 1);
  text-shadow: 0 0 10px rgba(0, 255, 128, 0.7);
  font-weight: bold;
}
</style>
